import React, { ReactElement, FunctionComponent, memo } from 'react'
import Grid from '@sport1/react-elements/Grid'
import { TestID } from '../../../utils/PropTypesDefinitions'

export type IndicatorProps = {
    /** the progress of the indicator in percent */
    indicatorPercent: number
} & TestID

const ProgressIndicator: FunctionComponent<IndicatorProps> = ({
    indicatorPercent,
    testID,
}): ReactElement => {
    return (
        <Grid noExpand backgroundColor="moon-3" testID={testID}>
            <Grid noExpand height={2} width={`${indicatorPercent}%`} backgroundColor="ORANGE" />
        </Grid>
    )
}

export default memo(ProgressIndicator)
